<template>
	<div>
		<vue-element-loading :active="this.showLoading" spinner="spinner" color="rgb(0, 0, 0)" :text="$t('message.正在授权')" />
		<div class="grid-content maintitle">
			<span>{{$t('message.第三方平台授权')}}</span>
		</div>
		<div class="grid-content content-margin">
			<div class="buttonarea">
				<el-link :underline="false">
					<el-button size="medium" round @click="getPreAuth">
						{{$t('message.前往授权')}}
					</el-button>
				</el-link>
			</div>
		</div>
	</div>
</template>

<script>
	import VueElementLoading from 'vue-element-loading';
import {rejecthttp,changeflagCLOSED} from "@/utils/request";

	export default {
		name: "PreAuth",
		data() {
			return {
				filterText: "",
				tableData3: [],
				showLoading: false,
			};
		},
		watch: {},
		methods: {
			getPreAuth() {
				//this.showLoading = true;
				this.$http.get("/manage/wechatsdk/pre_auth_code", {}).then((doc) => {
					if (doc.data.Code != "MSGKEY_OK") {
						this.$message({
							type: "error",
							message: doc.data.Message,
						});
						this.showLoading = false;
					} else {
						console.log(doc.data);
						//    跳转外部链接
						// window.open(doc.data.data.preAuthUrl);
						this.showLoading = false;
						window.location.href = doc.data.data.preAuthUrl;
					}
				});
			},
		},
		created() {
			var authCode = this.$route.query.auth_code;
			//非授权完成打开的链接
			if (authCode == null || authCode == "") {
				return;
			}

			this.showLoading = true;

			var expiresIn = this.$route.query.expires_in;
			//发送到服务器
			let sendObj = {
				authCode : authCode,
				expiresIn : expiresIn,
			};
			console.log("send auth_cod=" + sendObj.authCode + ", expires_in=" + sendObj.expiresIn);
			this.$http.post("/manage/wechatsdk/auth_code", sendObj).then((doc) => {
					if (doc.data.Code != "MSGKEY_OK") {
						console.log(doc.data.Code);
						this.$message.error(doc.data.Message);
						this.showLoading = false;
			}
			else {
				console.log(doc.data);
				this.showLoading = false;
				this.$message.success($t('message.授权成功'));
			}
		});

	},
	components: {
		VueElementLoading,
	},
	};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/wechatTag/PreAuth.vue